<template>
    
</template>

<script>
import { setCookie,getCookie,delCookie } from '../assets/js/cookie.js'
export default {
    mounted() {
        let token = getCookie('2officesessionid')
        
        /*如果cookie不存在，则跳转到登录页*/
        if(token == ""){
            this.$router.push('/')
            return
        }
        this.GLOBAL.token = token
    },
}
</script>



// WEBPACK FOOTER //
// src/components/cookie.vue